<div class="loader-wrapper">
  <ng-container>
    <div class="row">
      <div class="col posts-wrapper">
        <mat-tab-group
          (selectedTabChange)="onTabChanged($event.index)"
          mat-stretch-tabs="false"
        >
          <mat-tab [id]="0" [disabled]="!campaign">
            <ng-template mat-tab-label>
              <div class="download-tab-label">
                <div class="tab-title">
                  {{ "brand.campaign.posts.published" | translate }}
                  <span *ngIf="postLogSummary"
                    >({{ postLogSummary.publishedPosts ?? 0 }}
                    {{ "shared.posts" | translate }} /
                    {{ postLogSummary.publishedAds ?? 0 }}
                    {{ "shared.ads" | translate }})
                  </span>
                </div>
              </div>
            </ng-template>
            <section
              class="type-section"
              *ngIf="campaign && selectedTabStatus === PostLogStatus.Published"
            >
              <app-brand-campaign-posts-filters
                (filterPosts)="filterPosts($event)"
              />
              <p class="text-dark-grey"></p>
              <app-brand-campaign-posts-list
                *ngIf="!loading"
                [type]="PostLogStatus.Published"
                [posts]="postLogs"
                [campaign]="campaign"
              />
              <div *ngIf="loading" class="loader-container">
                <app-page-loader
                  [text]="'shared.loadingCampaign' | translate"
                />
              </div>
              <div class="table-pagination-footer">
                <mat-paginator
                  #paginator
                  class="paginator--centered"
                  [length]="totalElements"
                  [pageSize]="PAGE_SIZE"
                  [hidePageSize]="true"
                  (page)="onPageChange($event)"
                />
              </div>
            </section>
          </mat-tab>
          <mat-tab [id]="1" [disabled]="!campaign">
            <ng-template mat-tab-label>
              <div class="download-tab-label">
                <div class="tab-title">
                  {{ "brand.campaign.posts.scheduled" | translate }}
                  <span *ngIf="postLogSummary"
                    >({{ postLogSummary.scheduledPosts ?? 0 }}
                    {{ "shared.posts" | translate }} /
                    {{ postLogSummary.scheduledAds ?? 0 }}
                    {{ "shared.ads" | translate }})</span
                  >
                </div>
              </div>
            </ng-template>
            <section
              class="type-section"
              *ngIf="campaign && selectedTabStatus === PostLogStatus.Scheduled"
            >
              <app-brand-campaign-posts-filters
                (filterPosts)="filterPosts($event)"
              />
              <p class="text-dark-grey"></p>
              <app-brand-campaign-posts-list
                *ngIf="!loading"
                [type]="PostLogStatus.Scheduled"
                [posts]="postLogs"
                [campaign]="campaign"
              />
              <div *ngIf="loading" class="loader-container">
                <app-page-loader
                  [text]="'shared.loadingCampaign' | translate"
                />
              </div>
              <div class="table-pagination-footer">
                <mat-paginator
                  class="paginator--centered"
                  [length]="totalElements"
                  [pageSize]="PAGE_SIZE"
                  [hidePageSize]="true"
                  (page)="onPageChange($event)"
                />
              </div>
            </section>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </ng-container>
</div>
